import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./style.css";

const Testimonials = [
  {
    name: "Students & Parents",
    description:
      "Hear how students transformed their futures through global education and how families gained confidence in making life-changing decisions.",
    cta: "Watch Student Stories",
    testimonialRedirectUrl: "https://www.youtube.com/shorts/bl0XXYAv58A",
  },
  {
    name: "Franchisee Partners",
    description:
      "Discover how entrepreneurs built successful study abroad businesses with guidance, systems, and support from Asslam Shaikh and his team.",
    cta: "Watch Partner Stories",
    testimonialRedirectUrl: "https://www.youtube.com/watch?v=1wXKqvcAPEY",
  },
  {
    name: "University Partners & Consulates",
    description:
      "See what international universities, government bodies, and consular representatives have to say about working together to create global opportunities.",
    cta: "View Testimonials",
    testimonialRedirectUrl: "https://www.youtube.com/watch?v=BSKy6J7rgvk",
  },
];

const Testimonial = () => {
  var settings = {
    dots: false,
    arrows: false,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1500,
        settings: { slidesToShow: 2, slidesToScroll: 1 },
      },
      {
        breakpoint: 1200,
        settings: { slidesToShow: 2, slidesToScroll: 1 },
      },
      {
        breakpoint: 991,
        settings: { slidesToShow: 2, slidesToScroll: 1 },
      },
      {
        breakpoint: 767,
        settings: { slidesToShow: 1, slidesToScroll: 1 },
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 1, slidesToScroll: 1 },
      },
    ],
  };

  return (
    <section className="tp-testimonial-section section-padding">
      <div className="container">
        <div className="tp-section-title">
          <span>Testimonials</span>
          <h2>Stories of Impact</h2>
        </div>

        <div className="tp-testimonial-wrap">
          <Slider {...settings}>
            {Testimonials.map((tstml, tsm) => (
              <div className="tp-testimonial-item testimonial-card" key={tsm}>
                <i className="fi flaticon-quote testimonial-quote-bg"></i>
                <div className="tp-testimonial-text">
                  <p>{tstml.description}</p>
                  <div className="testimonial-card-footer">
                    <span className="testimonial-name">{tstml.name}</span>
                    <a
                      href={tstml.testimonialRedirectUrl}
                      target="_blank"
                      className="theme-btn testimonial-cta-btn"
                    >
                      {tstml.cta}
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
      <div className="visible-rotate-text">
        <h1>Review</h1>
      </div>
    </section>
  );
};

export default Testimonial;
